module.exports = __webpack_public_path__ + "static/media/star-empty.bbbe2316.svg";